<template>
  <div class="formBox">
    <LoadingSpinner v-if="loadingStatus || loading" />
    <div id="pqPopup"></div>
    <ChangeTopicStatusPopup
      ref="changeTopicStatusPopup"
      @statusChanged="statusChanged"
      @statusTopicLinkChanged="statusTopicLinkChanged"
    ></ChangeTopicStatusPopup>

    <DxPopup
      v-model:visible="popup.visible"
      :title="popup.title"
      width="auto"
      height="auto"
      container="#pqPopup"
      content-template="formTemplate"
    >
      <template #formTemplate>
        <DxValidationGroup name="validationGroup" ref="validationGroup">
          <div class="page-content">
            <div class="na-page">
              <form class="na-form" @submit="onSubmit($event)" ref="form">
                <div
                  id="cisTey"
                  :class="{
                    home: true,
                    crmReadOnly: formIsReadOnly,
                    crmEditForm: !formIsReadOnly,
                  }"
                >
                  <div class="controlHeader" v-if="!loadingStatus">
                    <div class="crmButton crmBackButton">
                      <DxButton
                        :text="btn.BtnBackToView"
                        styling-mode="text"
                        type="default"
                        icon="fa-regular fa-circle-arrow-left"
                        @click="backToOverview"
                      />
                    </div>
                    <div class="crmButton" v-if="!formIsReadOnly">
                      <DxButton
                        :text="btn.BtnSave"
                        styling-mode="text"
                        icon="fa-light fa-floppy-disk"
                        type="success"
                        @click="update"
                      />
                    </div>
                    <!--<div class="crmButton">
                                            <DxButton :text="btn.BtnDeepLink"
                                                      styling-mode="text"
                                                      icon="fa-light fa-floppy-disk"
                                                      type="success"
                                                      @click="getDeepLink" />
                                        </div>xxxxx-->
                  </div>
                  <div
                    class="crmContentArea"
                    v-bind:class="{
                      'cluster-class': topicTypeId == 23,
                      crmReadOnly: formIsReadOnly,
                    }"
                  >
                    <div class="crmTitle" v-if="entryTitle > ''">
                      <div class="crmCaption" v-html="entryTitle"></div>
                    </div>
                    <div
                      v-for="data in modulTypeAttributeList"
                      :key="data.MatId"
                    >
                      <!--isVisible = {{ isVisible(data) }}-->
                      <div
                        :class="[
                          data.className,
                          data.ControlClass,
                          'crmElements',
                        ]"
                        v-if="
                          isVisible(data) &&
                          data.AtrId != 15 &&
                          (!formIsReadOnly ||
                            (data.Value != null && data.Value != '') ||
                            data.AtyId == 5)
                        "
                      >
                        <div class="crmElementHeader">
                          <div
                            class="crmCaptionBox"
                            v-if="
                              data.Caption &&
                              data.Caption > '' &&
                              (!data.HideCaptionInReadonly || !formIsReadOnly)
                            "
                          >
                            <div class="crmCaption" v-html="data.Caption"></div>
                          </div>
                          <div v-if="data.AtyId == 9">
                            <DxCheckBox
                              v-model:value="data.Value"
                              class="crmCheckbox"
                              :readOnly="formIsReadOnly"
                              :enableThreeStateBehavior="false"
                            ></DxCheckBox>
                          </div>
                          <div class="crmRequired" v-if="!formIsReadOnly">
                            {{ data.Required ? "*" : "" }}
                          </div>
                        </div>
                        <div
                          class="crmDescription"
                          v-if="!formIsReadOnly"
                          v-html="data.Description"
                        ></div>
                        <div class="crmControl">
                          <div v-if="data.AtyId == 23" class="crmContents">
                            <div v-html="data.Value" class="crmTemplate"></div>
                          </div>
                          <div
                            v-if="data.AtyId == 1 || data.AtyId == 2"
                            class="crmContents"
                          >
                            <div v-if="formIsReadOnly" class="crmContents">
                              <dív
                                v-if="data.DisplayAsHtml"
                                class="crmContents"
                              >
                                <div
                                  v-html="removeFormatting(data.Value)"
                                  class="crmContents"
                                ></div>
                              </dív>
                              <dív
                                v-if="!data.DisplayAsHtml"
                                class="crmContents"
                              >
                                <div
                                  v-if="
                                    isUrl(data.Value) ||
                                    (data.AtyId == 1 && data.MatIsHyperLink)
                                  "
                                >
                                  <a
                                    v-html="data.Value"
                                    :href="data.MatHyperLinkText"
                                    target="_blank"
                                    class="crmContents crmHyperlink"
                                    v-if="
                                      data.AtyId == 1 && data.MatIsHyperLink
                                    "
                                  >
                                  </a>
                                  <a
                                    v-else
                                    :href="data.Value"
                                    target="_blank"
                                    class="crmContents crmHyperlink"
                                    >{{ data.Value }}</a
                                  >
                                </div>

                                <div
                                  v-else
                                  v-html="makeBreaks(data.Value)"
                                ></div>
                              </dív>
                            </div>
                            <div v-if="!formIsReadOnly" class="crmContents">
                              <DxTextBox
                                v-if="
                                  data.AtyId == 1 && data.DisplayAsHtml == false
                                "
                                v-model:value="data.Value"
                                :placeholder="data.ToolTip"
                                :hint="data.ToolTip"
                                value-change-event="keyup"
                                :max-length="data.MaxLength"
                              >
                                <DxValidator name="data.Caption">
                                  <DxRequiredRule
                                    v-if="data.Required"
                                    :message="data.RequiredMessage"
                                  />
                                </DxValidator>
                              </DxTextBox>
                              <DxTextArea
                                v-if="
                                  data.AtyId == 2 && data.DisplayAsHtml == false
                                "
                                v-model:value="data.Value"
                                :placeholder="data.ToolTip"
                                :hint="data.ToolTip"
                                value-change-event="keyup"
                                :autoResizeEnabled="true"
                                :max-length="data.MaxLength"
                              >
                                <DxValidator name="data.Caption">
                                  <DxRequiredRule
                                    v-if="data.Required"
                                    :message="data.RequiredMessage"
                                  />
                                </DxValidator>
                              </DxTextArea>
                              <DxHtmlEditor
                                v-if="data.DisplayAsHtml == true"
                                :placeholder="data.ToolTip"
                                :hint="data.ToolTip"
                                v-model:value="data.Value"
                              >
                                <DxValidator name="data.Caption">
                                  <DxRequiredRule
                                    v-if="data.Required"
                                    :message="data.RequiredMessage"
                                  />
                                </DxValidator>
                                <DxMediaResizing :enabled="true" />
                                <DxToolbar :multiline="isMultiline">
                                  <DxItem name="undo" />
                                  <DxItem name="redo" />
                                  <DxItem name="separator" />
                                  <DxItem
                                    :accepted-values="sizeValues"
                                    name="size"
                                  />
                                  <DxItem
                                    :accepted-values="fontValues"
                                    name="font"
                                  />
                                  <DxItem name="separator" />
                                  <DxItem name="bold" />
                                  <DxItem name="italic" />
                                  <DxItem name="strike" />
                                  <DxItem name="underline" />
                                  <DxItem name="separator" />
                                  <DxItem name="alignLeft" />
                                  <DxItem name="alignCenter" />
                                  <DxItem name="alignRight" />
                                  <DxItem name="alignJustify" />
                                  <DxItem name="separator" />
                                  <DxItem name="orderedList" />
                                  <DxItem name="bulletList" />
                                  <DxItem name="separator" />
                                  <DxItem
                                    :accepted-values="headerValues"
                                    name="header"
                                  />
                                  <DxItem name="separator" />
                                  <DxItem name="color" />
                                  <DxItem name="background" />
                                  <DxItem name="separator" />
                                  <DxItem name="link" />
                                  <DxItem name="image" />
                                  <DxItem name="separator" />
                                  <DxItem name="clear" />
                                  <DxItem name="codeBlock" />
                                  <DxItem name="blockquote" />
                                  <DxItem name="separator" />
                                  <DxItem name="insertTable" />
                                  <DxItem name="deleteTable" />
                                  <DxItem name="insertRowAbove" />
                                  <DxItem name="insertRowBelow" />
                                  <DxItem name="deleteRow" />
                                  <DxItem name="insertColumnLeft" />
                                  <DxItem name="insertColumnRight" />
                                  <DxItem name="deleteColumn" />
                                </DxToolbar>
                              </DxHtmlEditor>
                              <div
                                class="crmMaxLen"
                                v-html="getMaxLengthText(data)"
                              ></div>
                            </div>
                          </div>

                          <div v-if="data.AtyId == 3">
                            <div v-if="!formIsReadOnly" class="crmContents">
                              <DxSelectBox
                                v-model:value="data.Value"
                                v-model:text="data.SelectedText"
                                :data-source="data.SelectBoxItems"
                                :search-enabled="true"
                                search-mode="contains"
                                display-expr="Text"
                                value-expr="Value"
                                placeholder="Select a value..."
                              >
                                <DxValidator name="data.Caption">
                                  <DxRequiredRule
                                    v-if="data.Required"
                                    :message="data.RequiredMessage"
                                  />
                                </DxValidator>
                              </DxSelectBox>
                            </div>
                            <div v-if="formIsReadOnly" class="crmContents">
                              <div class="msbSelectBox">
                                <i
                                  :class="handleIcon(data.SelectBoxItems, data)"
                                ></i>
                                <div
                                  class="sbList"
                                  v-html="
                                    handleDisplayText(data.SelectBoxItems, data)
                                  "
                                ></div>
                              </div>
                            </div>
                          </div>
                          <div v-if="data.AtyId == 5"></div>
                          <div v-if="data.AtyId == 9"></div>
                          <div v-if="data.AtyId == 11" class="crmContents">
                            <div v-if="formIsReadOnly" class="crmContents">
                              {{ this.moment(data.Value).format(data.Format) }}
                            </div>
                            <div v-if="!formIsReadOnly" class="crmContents">
                              <DxDateBox
                                v-model:value="data.Value"
                                :type="data.DataType"
                                :dateSerializationFormat="
                                  data.DataType == 'date'
                                    ? 'yyyy-MM-dd'
                                    : 'yyyy-MM-ddTHH:mm:ss'
                                "
                                :use-mask-behavior="true"
                                :display-format="
                                  data.DataType == 'date'
                                    ? 'dd/MM/yyyy'
                                    : 'dd/MM/yyyy HH:mm'
                                "
                                :placeholder="data.ToolTip"
                                :show-clear-button="true"
                              >
                                <DxValidator name="data.Caption">
                                  <DxRequiredRule
                                    v-if="data.Required"
                                    :message="data.RequiredMessage"
                                  />
                                </DxValidator>
                              </DxDateBox>
                            </div>
                          </div>
                          <div v-if="data.AtyId == 18" class="crmContents">
                            <div v-if="formIsReadOnly" class="crmContents">
                              {{ data.Value }}
                            </div>
                            <div v-if="!formIsReadOnly" class="crmContents">
                              <DxNumberBox
                                v-model:value="data.Value"
                                :show-clear-button="true"
                                :show-spin-buttons="true"
                                mode="number"
                              >
                                <DxValidator name="data.Caption">
                                  <DxRequiredRule
                                    v-if="data.Required"
                                    :message="data.RequiredMessage"
                                  />
                                </DxValidator>
                              </DxNumberBox>
                            </div>
                          </div>
                          <div v-if="data.AtyId == 14 || data.AtyId == 21">
                            <div
                              v-if="!formIsReadOnly"
                              class="crmContents crmMultiSelectListText"
                            >
                              <ul class="crmMultiSelectListText">
                                <li
                                  v-for="rec in data.allItems.filter(
                                    (m) => m.selected == true
                                  )"
                                  :key="rec.value"
                                  class="crmMultiSelectItem"
                                >
                                  <span class="crmMultiSelectItemText">{{
                                    rec.text
                                  }}</span>
                                  <span
                                    class="crmMultiSelectItemDelete"
                                    @click="deleteMultiselectItem(data, rec)"
                                    ><i class="fa-regular fa-circle-xmark"></i
                                  ></span>
                                </li>
                                <li
                                  class="crmMultiSelectItem crmMultiSelectItemAdd"
                                  @click="addMultiselectItem(data)"
                                >
                                  <div class="crmMultiSelectIconAdd">
                                    <i class="fa-solid fa-plus"></i>
                                  </div>
                                </li>
                              </ul>
                              <DxNumberBox
                                :value="
                                  data.Value > ''
                                    ? data.Value.split(',').length
                                    : 0
                                "
                                :element-attr="{ class: 'crmValidationBox' }"
                                :readOnly="true"
                                :min="data.MinLength"
                                :max="data.MaxLength"
                              >
                                <DxValidator name="data.Caption">
                                  <DxRangeRule
                                    :min="data.MinLength"
                                    :max="99999999"
                                    type="range"
                                    :message="data.RangeMessage"
                                    :reevaluate="true"
                                  />
                                </DxValidator>
                              </DxNumberBox>
                              <DxPopup
                                v-model:visible="data.ShowSelectionPopup"
                                :hide-on-outside-click="false"
                                title="Please Select"
                                :height="500"
                                :width="500"
                                :show-close-button="true"
                              >
                                <div class="crmPopupContent">
                                  <div class="crmPopupBody">
                                    <DxTreeView
                                      id="treeview"
                                      v-model:value="data.Value"
                                      height="100%"
                                      ref="treeViewRef"
                                      :items="data.groupData"
                                      show-check-boxes-mode="normal"
                                      :search-enabled="true"
                                      search-mode="contains"
                                      keyExpr="Value"
                                      selectedExpr="selected"
                                      expandedExpr="expand"
                                      selection-mode="multiple"
                                      @itemRenderedX="
                                        (e) => treeItemRender(e, data)
                                      "
                                      @itemSelectionChanged="
                                        (e) => treeClick(e, data)
                                      "
                                      @selection-changed="
                                        (e) => treeViewSelectionChanged(e, data)
                                      "
                                      :select-nodes-recursive="false"
                                      :select-by-click="true"
                                    >
                                      <template #item="item">
                                        {{ item.data.text }}
                                      </template>
                                    </DxTreeView>
                                  </div>
                                  <div class="crmPopupFooter">
                                    <DxButton
                                      :text="btn.BtnSelect"
                                      type="default"
                                      @click="closeMultiselectPopup(data)"
                                    ></DxButton>
                                  </div>
                                </div>
                              </DxPopup>
                            </div>
                            <div v-if="formIsReadOnly" class="crmContents">
                              <div class="msbListBox">
                                <ul
                                  class="msbList"
                                  v-html="
                                    handleMultiSelectText(
                                      data.SelectBoxItems,
                                      data.SelectedKeys,
                                      data
                                    )
                                  "
                                ></ul>
                              </div>
                            </div>
                          </div>
                          <div v-if="data.AtyId == 17 && data.MatOptions">
                            <DxSlider
                              v-model:value="data.Value"
                              :disabled="formIsReadOnly"
                              :min="data.MatOptionsParsed.from"
                              :max="data.MatOptionsParsed.to"
                              :step="data.MatOptionsParsed.step"
                            >
                              <DxLabel :visible="true" position="top"></DxLabel>
                            </DxSlider>
                          </div>
                          <div
                            v-if="data.AtyId == 19 && data.Value != null"
                            class="crmImageBox"
                          >
                            <div
                              v-for="img in data.Value"
                              :key="img.TfiId"
                              class="crmImages"
                            >
                              <div
                                v-if="
                                  img.MediaType == 'Image' ||
                                  img.MediaType == 'Picture'
                                "
                                class="crmImageDiv"
                              >
                                <a :href="img.SourceUrl" target="_blank">
                                  <div class="crmImage">
                                    <img :src="img.Url" />
                                  </div>
                                </a>
                                <div
                                  class="crmImageDelete"
                                  v-if="!formIsReadOnly"
                                >
                                  <DxButton
                                    icon="fa fa-trash"
                                    @click="deleteImage(img, data)"
                                  ></DxButton>
                                </div>
                                <div
                                  :class="{
                                    crmDownload: true,
                                    crmDownloadReadonly: formIsReadOnly,
                                  }"
                                >
                                  <a
                                    class="downloadDocument"
                                    :href="img.SourceUrl"
                                    target="_blank"
                                    :download="img.TfiFileName"
                                  >
                                    <i
                                      class="fa-light fa-arrow-down-to-line"
                                    ></i>
                                    {{ img.TfiFileName }}
                                  </a>
                                </div>
                              </div>
                              <div
                                v-if="
                                  img.MediaType != 'Image' &&
                                  img.MediaType != 'Picture'
                                "
                                class="crmDocumentDiv"
                              >
                                <div class="crmImage">
                                  <a :href="img.Url" target="_blank"
                                    ><i class="fa-duotone fa-file-contract"></i
                                  ></a>
                                </div>
                                <div
                                  class="crmImageDelete"
                                  v-if="!formIsReadOnly"
                                >
                                  <DxButton
                                    icon="fa fa-trash"
                                    @click="deleteImage(img, data)"
                                  ></DxButton>
                                </div>
                                <div
                                  :class="{
                                    crmDownload: true,
                                    crmDownloadReadonly: formIsReadOnly,
                                  }"
                                >
                                  <a
                                    :href="img.Url"
                                    target="_blank"
                                    :download="img.TfiFileName"
                                  >
                                    <i
                                      class="fa-light fa-arrow-down-to-line"
                                    ></i>
                                    {{ img.TfiFileName }}
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            v-if="data.AtyId == 19 && !formIsReadOnly"
                            class="crmContents crmUpload"
                          >
                            <DxNumberBox
                              :value="data.Value.length"
                              :readOnly="true"
                              :element-attr="{ class: 'crmValidationBox' }"
                              :min="data.MinFilesCount"
                              :max="data.MaxFilesCount"
                            >
                              <DxValidator name="data.Caption">
                                <DxRangeRule
                                  :min="data.MinFilesCount"
                                  :max="data.MaxFilesCount"
                                  type="range"
                                  :message="data.RangeMessage"
                                  :reevaluate="true"
                                />
                              </DxValidator>
                            </DxNumberBox>
                            <DxFileUploader
                              :select-button-text="btn.BtnSelectFile"
                              :disabled="
                                data.Value &&
                                data.MatMaxFiles > 0 &&
                                data.Value.length >= data.MatMaxFiles
                              "
                              :label-text="data.ToolTip"
                              :tool-tip="data.ToolTip"
                              :max-file-size="data.MaxLength"
                              :min-file-size="data.MinLength"
                              :accept="data.RtmMimeType"
                              @uploaded="(e) => fileUploaded(e, data)"
                              @value-changed="
                                (e) => addUploadParameter(e, data)
                              "
                              upload-mode="instantly"
                              :upload-url="uploadUrl"
                            >
                              <DxValidator name="data.Caption">
                                <DxCustomRule
                                  :validation-callback="
                                    (e) => fileValidating(e, data)
                                  "
                                  message="x"
                                />
                              </DxValidator>
                            </DxFileUploader>
                          </div>
                          <div v-if="data.AtyId == 22">
                            <div class="crmPhotoBox">
                              <div
                                class="crmNoPhoto"
                                v-if="
                                  !data.Value ||
                                  !data.Value.Url ||
                                  data.Value.Url.length == 0
                                "
                              >
                                <div
                                  class="crmNoPhotoText"
                                  v-if="!formIsReadOnly"
                                >
                                  {{ data.ToolTip }}
                                </div>
                              </div>
                              <img
                                v-else
                                :src="data.Value ? data.Value.Url : null"
                              />
                              <div
                                v-if="!formIsReadOnly"
                                class="crmUploadButton"
                              >
                                <my-upload
                                  field="img"
                                  @crop-success="
                                    (imgDataUrl, field) =>
                                      cropSuccess(imgDataUrl, field, data.Value)
                                  "
                                  @crop-upload-success="cropUploadSuccess"
                                  @crop-upload-fail="cropUploadFail"
                                  v-model="showCropper"
                                  :width="
                                    data.MatOptionsParsed != null &&
                                    data.MatOptionsParsed.MinWidth != null
                                      ? data.MatOptionsParsed.MinWidth
                                      : 250
                                  "
                                  :height="
                                    data.MatOptionsParsed != null &&
                                    data.MatOptionsParsed.MinHeight != null
                                      ? data.MatOptionsParsed.MinHeight
                                      : 250
                                  "
                                  :params="cropperParams"
                                  :headers="cropperHeaders"
                                  :langExt="cropperLanguageExtend"
                                  img-format="png"
                                ></my-upload>

                                <DxButton
                                  text="Select File"
                                  @click="toggleShowCropper"
                                ></DxButton>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="crmElements"
                      v-if="showVoting || allowPublicVoting"
                    >
                      <div v-if="showVoting" class="crmVotingArea">
                        <TopicVoting
                          :topicId="currentTopicId"
                          :rtgId="rtgId"
                        ></TopicVoting>
                      </div>
                      <div v-if="allowPublicVoting" class="crmVotingArea">
                        <TopicPublicVoting
                          :topicId="currentTopicId"
                          :rtgId="publicVotingRtgId"
                        ></TopicPublicVoting>
                      </div>
                      <!--<div v-if="publicVotingConfig.AllowView" class="crmVotingArea">
                                                <TopicPublicVoting :topicId="currentTopicId"></TopicPublicVoting>
                                            </div>-->
                    </div>

                    <div
                      v-if="
                        topicLinkListHasStgPublished &&
                        (showLinkStatusInfo || showStatusInfo) &&
                        showGrids
                      "
                      class="drawers"
                    >
                      <DxButton
                        @click="openDrawerGrid"
                        type="default"
                        styling-mode="text"
                        class="drawer-btn"
                      >
                        <div class="drawer-title drawer-status-text">
                          <span>Tables</span>
                          <i class="fa-light fa-caret-down" />
                        </div>
                      </DxButton>
                      <DxLoadPanel
                        :position="{ of: '#linkListDrawer1' }"
                        v-model:visible="loadingLinkListVisible"
                        :show-indicator="true"
                        :show-pane="true"
                        :shading="true"
                        shading-color="rgba(0,0,0,0.4)"
                      />
                      <DxDrawer
                        id="linkListDrawer1"
                        opened-state-mode="shrink"
                        :position="selectedPosition"
                        :reveal-mode="selectedRevealMode"
                        v-model:opened="openStateGrid"
                        :close-on-outside-click="true"
                        template="drawerGrid"
                      >
                        <template #drawerGrid>
                          <div class="drawerGrid-elements">
                            <div
                              v-for="topicLink in topicLinkList"
                              :key="topicLink.TltId"
                              class="grid-element"
                            >
                              <!--{{topicLink}}-->
                              Gr
                              <DxDataGrid
                                :data-source="
                                  topicLink.Topics.filter((m) => m.StgId == 15)
                                "
                                :key-expr="TopicId"
                                :filter-row-visible="true"
                                :allow-column-reordering="true"
                                :allowColumnResizing="true"
                                @exporting="onExporting"
                                :show-borders="true"
                                columnAutoWidth="true"
                                :row-alternation-enabled="true"
                                v-if="
                                  topicLink.Topics.filter((m) => m.StgId == 15)
                                    .length > 0 && topicLink.TltId != 8
                                "
                              >
                                <DxScrolling row-rendering-mode="standard" />
                                <DxPaging :page-size="10" />
                                <DxPager
                                  :visible="true"
                                  :allowed-page-sizes="pageSizes"
                                  :display-mode="full"
                                  :show-page-size-selector="true"
                                  :show-info="true"
                                  :show-navigation-buttons="true"
                                />
                                <DxExport
                                  :enabled="true"
                                  :formats="['xlsx', 'pdf']"
                                  :allow-export-selected-data="true"
                                />
                                <DxSelection
                                  :show-check-boxes-mode="checkBoxesMode"
                                  mode="multiple"
                                  select-all-mode="allPages"
                                  allow-select-all="true"
                                />
                                <DxColumn
                                  :group-index="0"
                                  data-field="TltCaptionDirection2"
                                  :caption="column.ColType"
                                />
                                <DxColumn
                                  data-field="TopicId"
                                  :width="100"
                                  :allow-editing="false"
                                  :sort-index="0"
                                  caption="Id"
                                  data-type="string"
                                />
                                <DxColumn
                                  :allow-editing="false"
                                  :sort-index="0"
                                  :caption="column.Colname"
                                  data-type="string"
                                  :customize-text="customizeText"
                                  data-field="ParsedHtml"
                                />
                                <DxColumn
                                  :allow-editing="false"
                                  :sort-index="0"
                                  :caption="column.ColRol"
                                  data-type="string"
                                  width="110"
                                  data-field="TtyName"
                                />

                                <DxColumn
                                  data-field="StatusName"
                                  :allow-editing="false"
                                  :sort-index="0"
                                  :caption="column.ColStatus"
                                  data-type="string"
                                />
                              </DxDataGrid>
                            </div>
                          </div>
                        </template>
                      </DxDrawer>
                    </div>

                    <div v-if="showComment" class="crmElements crmCommentArea">
                      <div class="crmCaption">
                        {{ btnTitle.Comments }}
                      </div>
                      <TopicComment :topicId="currentTopicId"></TopicComment>
                    </div>
                  </div>
                  <!--<div class="crmValidationSummaryBox" v-if="!loadingStatus">
                                        <DxValidationSummary id="crmValidationSummary" ref="validationSummary" />
                                    </div>-->
                  <div class="crmButtons" v-if="!loadingStatus">
                    <div class="crmContents">
                      <!--<div class="crmButton">
                                                <DxButton :text="btn.BtnBackToView"
                                                          type="default"
                                                          icon="fa-regular fa-circle-arrow-left"
                                                          :use-submit-behavior="false"
                                                          @click="backToOverview($event)" />
                                            </div>-->
                      <div class="crmButton" v-if="!formIsReadOnly">
                        <DxButton
                          :text="btn.BtnSave"
                          icon="fa-light fa-floppy-disk"
                          type="success"
                          @click="update"
                        />
                      </div>
                      <!--<div class="crmButton" v-if="topicAccess.Delete && !formIsReadOnly">
                                                <DxButton :text="currentTopicStatus.DeleteButtonText"
                                                          :icon="currentTopicStatus.DeleteButtonIcon && currentTopicStatus.DeleteButtonIcon.length > 0 ? currentTopicStatus.DeleteButtonIcon : 'fa-light fa-trash'"
                                                          type="danger"
                                                          @click="deleteTopic" />
                                            </div>-->
                      <div v-if="showStatusActions" style="display: contents">
                        <div
                          class="crmButton crmStatusSubmitButtons"
                          v-for="action in actionListForStatus"
                          :key="action.StatusID"
                        >
                          <DxButton
                            :text="action.ActionButtonText"
                            type="success"
                            :icon="
                              action.ActionButtonIcon &&
                              action.ActionButtonIcon.length > 0
                                ? action.ActionButtonIcon
                                : 'fa-light fa-plus'
                            "
                            @click="changeTopicStatus(action)"
                          />
                        </div>
                      </div>
                      <div
                        v-if="showLinkStatusActions"
                        style="display: contents"
                      >
                        <div
                          v-for="action in topicLinkActionList"
                          :key="action.TltId"
                          class="crmButton"
                          style="display: contents"
                        >
                          <div v-if="action.LinkCount < action.TltMax">
                            <DxButton
                              :text="action.TltCreateButtonText"
                              :icon="
                                action.ActionButtonIcon &&
                                action.ActionButtonIcon.length > 0
                                  ? action.ActionButtonIcon
                                  : 'fa-light fa-plus'
                              "
                              @click="addTopicLink(action)"
                              type="success"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </DxValidationGroup>
      </template>
    </DxPopup>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingSpinner from "@/views/widgets/LoadingSpinner";
import ChangeTopicStatusPopup from "@/views/widgets/ChangeTopicStatusPopup";
import { DxNumberBox } from "devextreme-vue/number-box";
import { DxDateBox } from "devextreme-vue/date-box";
import { DxCheckBox } from "devextreme-vue/check-box";
import { DxFileUploader } from "devextreme-vue/file-uploader";
import { DxButton } from "devextreme-vue/button";
import { DxSlider, DxLabel } from "devextreme-vue/slider";
import { DxTextBox } from "devextreme-vue/text-box";
import { DxTreeView } from "devextreme-vue/tree-view";
import { DxTextArea } from "devextreme-vue/text-area";
import { DxPopup } from "devextreme-vue/popup";
import { DxSelectBox } from "devextreme-vue/select-box";
import {
  DxHtmlEditor,
  DxItem,
  DxMediaResizing,
  DxToolbar,
} from "devextreme-vue/html-editor";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import TopicVoting from "@/views/TopicVoting";
import TopicPublicVoting from "@/views/TopicPublicVoting";
import TopicComment from "@/views/TopicComment";
import { htmlToText } from "html-to-text";
import DxValidationGroup from "devextreme-vue/validation-group";
import { alert, confirm } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";
import myUpload from "vue-image-crop-upload";
import DxDrawer from "devextreme-vue/drawer";
import {
  DxDataGrid,
  DxExport,
  DxColumn,
  DxSelection,
  DxScrolling,
  DxPaging,
  DxPager,
} from "devextreme-vue/data-grid";
import { Workbook } from "exceljs";
import { jsPDF } from "jspdf";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import {
  DxValidator,
  DxRequiredRule,
  DxCustomRule,
  DxRangeRule,
} from "devextreme-vue/validator";

const applicationServiceUri = "WebApi.asmx/api/applicationService";
const statusServiceUri = "WebApi.asmx/api/statusService";
const accessServiceUri = "WebApi.asmx/api/accessService";
const topicServiceUri = "WebApi.asmx/api/topicService";

export default {
  name: "topicEntry",
  components: {
    DxButton,
    DxTextBox,
    DxTextArea,
    DxHtmlEditor,
    DxItem,
    DxMediaResizing,
    DxToolbar,
    TopicPublicVoting,
    //DxDropDownBox, DxSelection, DxFilterRow,
    DxLoadPanel,
    DxCustomRule,
    DxScrolling,
    DxPaging,
    DxPager,
    LoadingSpinner,
    DxTreeView,
    DxFileUploader,
    DxValidator,
    DxCheckBox,
    //DxTagBox,
    //DxValidationSummary,
    DxRequiredRule,
    DxValidationGroup,
    DxRangeRule,
    DxDataGrid,
    DxColumn,
    DxExport,
    DxSelection,
    DxDrawer,
    ChangeTopicStatusPopup,
    "my-upload": myUpload,
    DxPopup,
    //DxScrollView,
    // DxCustomRule,
    TopicVoting,
    DxSlider,
    DxSelectBox,
    DxNumberBox,
    DxDateBox,
    DxLabel,
    TopicComment,
    //NetworkList
  },
  data() {
    return {
      args: {},
      title: "",
      visible: false,
      loadingLinkListVisible: true,
      selectedRevealMode: "expand",
      selectedPosition: "top",
      selectedOpenMode: "shrink",
      openState: true,
      openStateGrid: false,
      showUserSelection: false,
      showCropper: false,
      expertsListForGroup: [],
      modulTypeAttributeList: [],
      selectedExperts: [],
      accessList: [],
      topicIdList: [],
      topicLinksForLinking: [],
      topicLinkActionList: [],
      topicLinkList1: [],
      actionListForStatus: [],
      currentTopicStatus: { StatusId: null, StatusName: "", StgId: null },
      ttyInfo: {},
      formIsReadOnly: true,
      loadingStatus: false,
      allowPublicVoting: false,
      showVoting: false,
      publicVotingRtgId: false,
      currentTopicId: 0,
      rtgId: 0,
      ttyId: 0,
      topicId: 0,
      topicInfo: {},
      topicAccess: {
        Open: false,
        Update: false,
        New: false,
        Delete: false,
        InlineEdit: false,
        Visible: false,
        ChangeStatus: false,
      },
      pageSizes: [10, 15, 30],
      uploadUrl: "",
      cropperParams: {
        token: "12321",
        name: "avatar",
      },
      cropperHeader: {
        smail: "*_~",
      },
      titleValue: {},
      column: {
        ColStatus: this.$LanguageProvider.GetResource(
          "ColStatus",
          "Caption",
          "Status"
        ),
        ColAiFields: this.$LanguageProvider.GetResource(
          "ColAiFields",
          "Caption",
          "AI Fields"
        ),
        ColAiField1: this.$LanguageProvider.GetResource(
          "ColAiField1",
          "Caption",
          "AI Field 1"
        ),
        ColAiField2: this.$LanguageProvider.GetResource(
          "ColAiField2",
          "Caption",
          "AI Field 2"
        ),
        ColAiField3: this.$LanguageProvider.GetResource(
          "ColAiField3",
          "Caption",
          "AI Field 3"
        ),
        Colname: this.$LanguageProvider.GetResource(
          "Colname",
          "Caption",
          "Name"
        ),
        ColSalCaptionEN: this.$LanguageProvider.GetResource(
          "ColSalCaptionEN",
          "Caption",
          "Gender"
        ),
        ColUsrBirthDay: this.$LanguageProvider.GetResource(
          "ColUsrBirthDay",
          "Caption",
          "Birthday"
        ),
        ColRol: this.$LanguageProvider.GetResource(
          "ColRol",
          "Caption",
          "Membership"
        ),
        ColCity: this.$LanguageProvider.GetResource(
          "ColCity",
          "Caption",
          "City"
        ),
        ColUsrEMailOwner: this.$LanguageProvider.GetResource(
          "ColEmail",
          "Caption",
          "Email"
        ),
        ColCurtStatus: this.$LanguageProvider.GetResource(
          "ColCurtStatus",
          "Caption",
          "Current status"
        ),
        ColUni: this.$LanguageProvider.GetResource(
          "ColUni",
          "Caption",
          "University/Research Center"
        ),
        ColFoR: this.$LanguageProvider.GetResource(
          "ColFoR",
          "Caption",
          "Field of research"
        ),
        ColType: this.$LanguageProvider.GetResource(
          "ColType",
          "Caption",
          "Type"
        ),
      },
      cropperLanguageExtend: {
        hint: "Click or drag the file here to upload",
        loading: "Uploading…",
        noSupported:
          "Browser is not supported, please use IE10+ or other browsers",
        success: "Upload success",
        fail: "Upload failed",
        preview: "Preview",
        btn: {
          off: "Cancel",
          close: "Close",
          back: "Back",
          save: "Save",
        },
        error: {
          onlyImg: "Image only",
          outOfSize: "Image exceeds size limit: ",
          lowestPx: "Image's size is too low. Expected at least: ",
        },
      },
      popup: {
        visible: false,
        template: "",
        title: "",
        message: "",
        hasChangeNotification: false,
        showAssigneeSelection: false,
        showExpertsSelection: false,
        expertsGrpId: 0,
        mailText: "",
        multiselect: false,
        action: {},
      },
      actionTopicId: 0,
      actionCategoryId: 0,
      actionTlsId: 0,
      actionStatusId: 0,
      loading: false,
      limitMessageShown: false,
      moment: moment,
      submitAction: null,
      btnTitle: {
        Comments: this.$LanguageProvider.GetResource(
          "Comments",
          "Caption",
          "Kommentar"
        ),
      },
      btn: {
        BtnBackToView: this.$LanguageProvider.GetResource(
          "BtnBackToView",
          "Caption",
          "Back"
        ),
        BtnBack: this.$LanguageProvider.GetResource(
          "BtnBack",
          "Caption",
          "Back"
        ),
        BtnSave: this.$LanguageProvider.GetResource(
          "BtnSave",
          "Caption",
          "Save"
        ),
        BtnDeepLink: this.$LanguageProvider.GetResource(
          "BtnDeepLink",
          "Caption",
          "Get Deep Link"
        ),
        BtnDelete: this.$LanguageProvider.GetResource(
          "BtnDelete",
          "Caption",
          "Delete"
        ),
        BtnSelect: this.$LanguageProvider.GetResource(
          "BtnSelect",
          "Caption",
          "Select"
        ),
        BtnSelectFile: this.$LanguageProvider.GetResource(
          "BtnSelectFile",
          "Caption",
          "Select file"
        ),
        BtnSubmit: this.$LanguageProvider.GetResource(
          "BtnSubmit",
          "Caption",
          "Submit"
        ),
      },
    };
  },
  watch: {},
  computed: {
    actionTopicIds() {
      return this.topicLinksForLinking
        .filter((m) => m.selected == true)
        .map((m) => m.TopicId);
    },

    showAsFullscreen() {
      return window.innerWidth < 600;
    },
    topicLinkList() {
      var linkLists = this.topicLinkList1;
      linkLists.forEach((list) => {
        list.grouped = list.Topics.groupBy(
          (m) => {
            if (
              m.TltCaptionRequestDirection1 &&
              m.TltCaptionRequestDirection1 > "" &&
              m.StgId == 1
            )
              return {
                Order: 5,
                Caption1: m.TltCaptionRequestDirection1,
                Caption2: m.TltCaptionRequestDirection2,
              };
            if (
              m.TltCaptionSubmittedDirection1 &&
              m.TltCaptionSubmittedDirection1 > "" &&
              m.StgId == 10
            )
              return {
                Order: 10,
                Caption1: m.TltCaptionSubmittedDirection1,
                Caption2: m.TltCaptionSubmittedDirection2,
              };
            if (
              m.TltCaptionEvaluationDirection1 &&
              m.TltCaptionEvaluationDirection1 > "" &&
              m.StgId == 12
            )
              return {
                Order: 12,
                Caption1: m.TltCaptionEvaluationDirection1,
                Caption2: m.TltCaptionEvaluationDirection2,
              };
            if (
              m.TltCaptionDirection1 &&
              m.TltCaptionDirection1 > "" &&
              m.StgId == 15
            )
              return {
                Order: 0,
                Caption1: m.TltCaptionDirection1,
                Caption2: m.TltCaptionDirection2,
              };
            if (
              m.TltCaptionClosedDirection1 &&
              m.TltCaptionClosedDirection1 > "" &&
              m.StgId == 20
            )
              return {
                Order: 20,
                Caption1: m.TltCaptionClosedDirection1,
                Caption2: m.TltCaptionClosedDirection2,
              };
            return {
              Order: 5,
              Caption1: m.TltCaptionRequestDirection1,
              Caption2: m.TltCaptionRequestDirection2,
            };
          },
          (a, b) => {
            return a.Order == b.Order && a.Caption == b.Caption;
          }
        );
      });
      return linkLists;
    },
    topicLinkListHasStgPublished() {
      var result = this.topicLinkList1;
      var found = false;
      result.forEach((topic) => {
        if (topic.Topics.filter((m) => m.StgId == 15).length > 0) found = true;
      });
      return found;
    },
    entryTitle() {
      if (this.formIsReadOnly) {
        var first = this.topicLinkActionList.find(
          (m) => m.AtyId == 1 || m.AtyId == 2 || m.AtyId == 23
        );
        return first ? first.Value : "";
      } else {
        return "";
      }
    },
    record() {
      var obj = {};
      this.modulTypeAttributeList.forEach((m) => {
        obj.__defineGetter__(m.Name, () => m.Value);
        if (m.AtyId == 21) {
          obj.__defineGetter__(m.Name + "_Text", () => {
            if (m.listItems && m.listItems[0] && m.listItems[0].items) {
              return m.listItems[0].items
                .filter((e) => e.selected)
                .map((e) => e.text)
                .join(", ");
            }
            return "";
          });
        }
        if (m.AtyId == 19) {
          obj.__defineGetter__(m.Name + "_PictureCount", () => {
            if (m.Value && m.Value[0]) {
              return true;
            }
            return false;
          });
        } else {
          obj.__defineGetter__(m.Name + "_Text", () =>
            m.SelectedText ? m.SelectedText : ""
          );
        }
        obj.__defineGetter__(m.Name + "_Keys", () => m.SelectedKeys);
      });

      return obj;
    },
    showComment() {
      return false;
    },
    showNavigator() {
      return this.topicIdList && this.topicIdList.length > 1;
    },
    topicTypeId() {
      return this.ttyId;
    },
    pageTitle() {
      switch (this.topicTypeId) {
        case 23:
          return this.currentTopicStatus.StgId == 15 ? "Member" : "Applicant";
        default:
          return this.ttyInfo.TtyName;
      }
    },
    index() {
      return this.topicIdList.indexOf(this.currentTopicId);
    },
    hasFirst() {
      return this.index > 0;
    },
    hasPrevious() {
      return this.index > 0;
    },
    hasNext() {
      return this.topicIdList.length > this.index + 1;
    },
    hasLast() {
      return this.topicIdList.length > this.index + 1;
    },
    //topicsInSuchfeld() {
    //    var list = this.$store.state.iconListStore.topicCardList
    //    var result = list.filter(m => (this.rouId == 0 || this.rouId == m.RouId) &&
    //        (this.suchfeldId == 0 || (m.Suchfelder.includes(this.suchfeldId))))
    //    return result
    //},
  },
  mounted() {},
  created() {},
  methods: {
    // Find the Direction field reliably
    getDirectionField() {
      return (this.modulTypeAttributeList || []).find(
        (m) =>
          m.AtyId === 3 &&
          (m.AtrId === 495 || // robust: attribute id for Direction
            m.Caption === "Direction" || // fallback by caption
            m.Name === "TdgLisId002") // your current Name
      );
    },

    // Rename and generalize: relabel for both normal and reversed views
    applyDirectionUiLabels(reversed = this.isReversedDirection) {
      const fld = this.getDirectionField();
      if (!fld || !Array.isArray(fld.SelectBoxItems)) return;

      // keep originals and IDs for swapping later
      if (!fld._originalDirection) {
        fld._originalDirection = {
          Items: JSON.parse(JSON.stringify(fld.SelectBoxItems)),
        };
      }
      const orig = fld._originalDirection.Items;
      const one = orig.find((i) => i.Text === "1");
      const two = orig.find((i) => i.Text === "2");
      fld._dirVal1 = one ? one.Value : null;
      fld._dirVal2 = two ? two.Value : null;

      const mapText = (txt) => {
        switch (txt) {
          case "1":
            return reversed ? "mandated by" : "mandating";
          case "2":
            return reversed ? "mandating" : "mandated by";
          case "Both":
            return "related to";
          default:
            return txt; // 'None' or others
        }
      };

      // Rebuild the list from originals to avoid double transforms
      fld.SelectBoxItems = orig.map((o) => ({ ...o, Text: mapText(o.Text) }));
    },

    LoadData(topicId, args, title, isReversed = false) {
      this.topicId = topicId;
      this.args = args;
      this.title = title;
      this.popup.title = title;
      // console.log("LoadData topicId", this.topicId, " args: " + this.args);
      this.isReversedDirection = !!isReversed;
      this.visible = false;
      this.loading = true;

      Promise.all([
        this.getTopicAccess(), // updates this.topicAccess as a side effect
        this.GetGenericFormData({ args: this.args, topicId: this.topicId }),
      ]).then(([, formRes]) => {
        // wait for both; ignore the first result because we only need
        const baseReadOnly =
          formRes && formRes.data ? !!formRes.data.ReadOnly : false;
        this.formIsReadOnly = baseReadOnly || this.topicAccess.Update !== true;

        // Always relabel (normal words or reversed words)
        this.applyDirectionUiLabels();

        this.loading = false;
        this.visible = true;
        this.popup.visible = true;
      });
    },
    GetGenericFormData(data) {
      var formData = new FormData();
      formData.append("rfeId", data.rfeId);
      formData.append("ttyId", data.ttyId);
      formData.append("topicId", data.topicId);
      formData.append("rouId", data.rouId);
      formData.append("cmd", data.cmd);
      formData.append("args", data.args);
      //  console.log("GetGenericFormData data ", data.topicId1, data.args);
      return axios
        .post(applicationServiceUri + "/GetGenericFormData", formData)
        .then((res) => {
          if (res.data.success) {
            var posts = res.data;
            // console.log("* ", JSON.stringify(posts));
            this.mtaList = posts.formElements ? posts.formElements : [];
            this.mtaList.forEach((m) => {
              if (m.ToolTip == "") {
                m.ToolTip = m.Description;
              }
              m.oldValue = m.Value;
              m.RequiredMessage = m.Caption + " is required";
              if (m.AtyId == 19) {
                m.MinFilesCount = m.Required ? 1 : 0;
                m.MaxFilesCount = m.MatMaxFiles > 0 ? m.MatMaxFiles : 1;
                if (m.MinFilesCount > 0 && m.AtyId == 19) {
                  m.RangeMessage =
                    m.MaxFilesCount == 1
                      ? m.RequiredMessage
                      : m.Caption +
                        " must be between " +
                        m.MinFilesCount +
                        " and " +
                        m.MaxFilesCount +
                        " files";
                }
              }
              if (m.AtyId == 14 || m.AtyId == 21) {
                m.MinLength =
                  m.MinLength > 0 ? m.MinLength : m.Required ? 1 : 0;
                m.MaxLength =
                  m.MaxLength >= m.MinLength ? m.MaxLength : m.MinLength;
                if (m.MinLength > 0) {
                  m.RangeMessage =
                    m.MaxLength == 1
                      ? m.RequiredMessage
                      : m.Caption +
                        ": select between " +
                        m.MinLength +
                        " and " +
                        m.MaxLength +
                        " entries";
                }
              }
            });
            posts.ttyInfo.TtyDescription = htmlToText(
              posts.ttyInfo.TtyDescription
            );
            this.ttyInfo = posts.ttyInfo ? posts.ttyInfo : [];
            // formIsReadOnly will be computed after both access and form data are loaded
            this.currentTopicId = posts.topicId;
            this.showVoting = posts.ShowVoting;
            this.allowPublicVoting = posts.publicVotingConfig.AllowVoting;
            this.publicVotingRtgId = posts.publicVotingConfig.RtgId;
            this.rtgId = posts.RtgId;
            this.ttyId = posts.ttyId;
            this.topicId = posts.topicId;
            this.topicInfo.topicId = posts.topicId;
            this.topicInfo.schaltzeitId = posts.schaltzeitId;
            this.topicInfo.title = posts.title;
            this.topicInfo.OwnerUsrId = posts.OwnerUsrId;
            this.topicInfo.UsrLastName = posts.UsrLastName;
            this.topicInfo.UsrFirstName = posts.UsrFirstName;
            this.topicIdList = posts.TopicIdList ? posts.TopicIdList : [];
            var result = this.mtaList;
            var self = this;
            if (this.formIsReadOnly && result && result.length > 0) {
              result.forEach((m) => {
                if (m.AtyId == 2 && m.Value && m.Value.length > 1500)
                  m.className = "crmBreakInside";
                else m.className = "notCrmBreakInside";
              });
              var first = result.find(
                (m) => m.AtyId == 1 || m.AtyId == 2 || m.AtyId == 23
              );
              if (first && first.AtrId == 18) {
                self.titleValue = first;
                result = result.filter((m) => m != first);
              }
            }

            if (
              result &&
              result.length > 0 &&
              result[0].groupData == undefined
            ) {
              result.forEach((m) => {
                m.ShowSelectionPopup = false;
                m.groupData = this.processGrouped(m);
                var expand = m.groupData.length < 5;
                if (expand) {
                  m.groupData.forEach((g) => (g.expand = true));
                }
              });
            }
            this.modulTypeAttributeList = result;
            console.log(1);
            return res;
          } else {
            if (res.data.argsNotFound) {
              alert("not authorized");
            }
          }
          return res;
        });
    },
    getTopicAccess() {
      return axios
        .get(topicServiceUri + "/GetTopicAccess", {
          params: { args: this.args, topicId: this.topicId },
        })
        .then((res) => {
          if (res.data.success == true) {
            this.topicAccess = res.data.access;
            return res;
          } else {
            alert(res.data.errorMessage);
            return res;
          }
        });
    },
    getAccessList({ tokenList }) {
      var formData = new FormData();
      formData.append("args", JSON.stringify({ tokenList }));
      return axios
        .post(accessServiceUri + "/GetAccessList", formData)
        .then((res) => {
          if (res.data.success == true) {
            var result = {};
            res.data.accessList.forEach((m) => (result["_" + m] = true));
            this.accessList = result;
          } else {
            alert(res.data.errorMessage);
          }
          return res;
        });
    },

    getActionListByWorkflow(data) {
      return axios
        .get(
          statusServiceUri +
            "/GetActionListByWorkflow?args=" +
            data.args +
            "&topicId=" +
            data.topicId
        )
        .then((res) => {
          if (res.data.success == true) {
            this.actionListForStatus = res.data.list;
            this.currentTopicStatus = res.data.currentStatus;
            return res;
          } else {
            alert(res.data.errorMessage);
            return res;
          }
        });
    },
    onExporting(e) {
      if (e.format === "pdf") {
        const doc = new jsPDF();
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: e.component,
          indent: 5,
        }).then(() => {
          if (this.titleValue) doc.save(this.titleValue.Value);
          else doc.save("Report.pdf");
        });
      }
      if (e.format === "xlsx") {
        const workbook = new Workbook();
        workbook.title = "Report";
        if (this.titleValue) workbook.title = this.titleValue.Value;

        const worksheet = workbook.addWorksheet("Attendees");
        exportDataGrid({
          component: e.component,
          worksheet: worksheet,
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              workbook.title + ".xlsx"
            );
          });
        });
      }
    },
    customizeText(cellInfo) {
      return cellInfo.value.replace(/<\/?[^>]+(>|$)/g, "");
    },
    popupCancel: function () {
      this.popup.visible = false;
    },
    openDrawer: function () {
      this.openState = !this.openState;
    },
    openDrawerGrid: function () {
      this.openStateGrid = !this.openStateGrid;
    },
    statusChanged: function () {
      return Promise.all([
        this.getActionListByWorkflow({
          args: this.args,
          topicId: this.currentTopicId,
        }),
        this.getTopicAccess(),
      ]).then(() => {
        this.loading = false;
      });
    },
    selectExperts() {
      this.showUserSelection = true;
    },
    toggleShowCropper() {
      this.showCropper = !this.showCropper;
    },
    cropSuccess(imgDataUrl, field, value) {
      if (value) {
        value.UpdateData = imgDataUrl;
        value.Url = imgDataUrl;
      }
    },
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },

    ////////////////
    evaluate: function (code, args = {}) {
      // Call is used to define where "this" within the evaluated code should reference.
      // eval does not accept the likes of eval.call(...) or eval.apply(...) and cannot
      // be an arrow function
      return function evaluateEval() {
        // Create an args definition list e.g. "arg1 = this.arg1, arg2 = this.arg2"
        const argsStr = Object.keys(args)
          .map((key) => `${key} = this.${key}`)
          .join(",");
        const argsDef = argsStr ? `let ${argsStr};` : "";

        return eval(`${argsDef}${code}`);
      }.call(args);
    },
    isVisible: function (data) {
      console.log("isVisible1", data);
      if (data.VisibleCondition > "") {
        try {
          console.log("isVisible1", data.VisibleCondition);
          data.Visible = this.evaluate(data.VisibleCondition, this.record);
          console.log("isVisible2", data.Visible);
        } catch (e) {
          console.error("Error", e);
          data.Visible = false;
        }
      } else {
        data.Visible = true;
      }
      console.log("isVisibleEnde", data.Visible);
      return data.Visible;
    },
    changeTopicStatus: function (status) {
      let validationResult = this.$refs.validationGroup.instance.validate();
      const popup = this.$refs.changeTopicStatusPopup;
      if (!validationResult.isValid) {
        alert(
          "You must fill in all marked fields before you can perform this action!",
          "Confirm"
        );
        return;
      }
      if (!this.formIsReadOnly) {
        this.SaveGenericFormData({ submit: false, args: this.args }).then(
          (success) => {
            if (success) {
              popup.showTopicPopup(this.currentTopicId, status.StatusID);
            } else {
              alert("Error while saving your data");
            }
          }
        );
      } else {
        popup.showTopicPopup(this.currentTopicId, status.StatusID);
      }
    },
    SaveGenericFormData({ submit, args }) {
      submit = submit ? submit : false;

      // NOTE: Do not swap values on save. Reversal is presentation-only.
      const updateData = (this.modulTypeAttributeList || []).map((m) => ({
        Name: m.Name,
        Value: m.Value,
        SelectedKeys: m.SelectedKeys,
        Visible: m.Visible,
      }));

      const formData = new FormData();
      formData.append("data", JSON.stringify(updateData));
      formData.append("topicId", this.topicId);
      formData.append("submit", submit);
      formData.append("args", args);

      return axios
        .post(applicationServiceUri + "/SaveGenericFormData", formData)
        .then((res) => {
          if (res.data.success == true) {
            if (this.ttyId == 15)
              notify("Event information has been successfully saved.");
            else
              notify("Your profile information has been successfully saved.");
          } else {
            alert(res.data.errorMessage);
          }
          return res;
        });
    },

    closeMultiselectPopup(data) {
      data.ShowSelectionPopup = false;
    },
    deleteMultiselectItem(data, rec) {
      data.SelectedKeys = data.SelectedKeys.filter((m) => m != rec.value);
      data.Value = data.SelectedKeys.join(",");
      var tree = this.$refs.treeViewRef.instance;
      tree.unselectItem(rec);
    },
    addMultiselectItem(data) {
      data.ShowSelectionPopup = true;
      console.log(data);
    },
    getMaxLengthText(data) {
      if (!data.MaxLength || data.MaxLength == 0) {
        return "";
      }
      const n =
        data.Value && data.Value != null
          ? data.MaxLength - data.Value.length
          : data.MaxLength;
      return `${n} characters left`;
    },
    deleteImage(img, data) {
      let result = confirm(
        "Are you sure you want to delete this document?",
        "Confirm Deletion"
      );
      result.then((dialogResult) => {
        if (dialogResult) {
          this.loading = true;
          this.DeleteTopicFile({ args: this.args, img: img, data }).then(() => {
            this.loading = false;
          });
        }
      });
    },

    DeleteTopicFile({ args, img, data }) {
      var formData = new FormData();
      formData.append("TfiId", img.TfiId);
      formData.append("MatId", data.MatId);
      formData.append("args", args);
      axios
        .post(applicationServiceUri + "/DeleteDocument", formData)
        .then((res) => {
          if (res.data.success) {
            data.Value = data.Value.filter((m) => m.TfiId != img.TfiId);
          }
        });
    },
    treeItemRender(e, data) {
      var hasParents =
        data.SelectBoxItems.filter((m) => m.ParentValue > 0).length > 0;
      if (
        hasParents &&
        (e.itemData.parentValue == null || e.itemData.parentValue == "")
      ) {
        e.itemElement.parentElement.style.paddingLeft = 0;
        e.itemElement.parentElement
          .getElementsByClassName("dx-checkbox")
          .forEach((m) => {
            return (m.style.display = "none");
          });
      }
    },

    isTreeKeySelected(data, list) {
      var keys = [];

      if (data.hasParents) {
        list.forEach((m) => {
          if (m.selected) {
            // && m.parentValue > 0)
            keys.push(m.value);
          }
          if (m.items) {
            keys = keys.concat(this.isTreeKeySelected(data, m.items));
          }
        });
      } else {
        keys = data.listItems
          .filter((m) => m.selected)
          .map((m) => {
            return m.value;
          });
      }
      return keys;
    },
    treeClick(e, data) {
      switch (data.AtmId) {
        case 2:
          {
            var list = data.SelectedKeys;
            if (e.itemData.selected) {
              list.push(e.itemData.value);
            }
            const count = data.listItems.filter(
              (m) =>
                m.items.filter((i) => list.indexOf(i.value) >= 0).length > 0
            ).length;
            const max = data.listItems
              .map((m) => {
                return m.items.filter((i) => list.indexOf(i.value) >= 0).length;
              })
              .max();
            if (
              (data.MaxLength > 0 &&
                data.MaxLength < count &&
                e.itemData.selected == true) ||
              max > 3
            ) {
              e.component.unselectItem(e.itemElement);
              if (!this.limitMessageShown) {
                alert(
                  `Only a maximum of three elements per group from a maximum of ${data.MaxLength} groups can be selected.`,
                  "Selection Limit"
                );
                this.limitMessageShown = true;
              } else {
                this.limitMessageShown = false;
              }
            }
          }
          break;
        default:
          {
            const count = data.SelectedKeys.length;
            if (
              data.MaxLength > 0 &&
              data.MaxLength <= count &&
              e.itemData.selected == true
            ) {
              e.component.unselectItem(e.itemElement);
              if (!this.limitMessageShown) {
                alert(
                  `only ${data.MaxLength} items can be selected`,
                  "Selection Limit"
                );
                this.limitMessageShown = true;
              }
            }
          }
          break;
      }
    },
    treeClickEntryPoint() {},
    treeViewSelectionChanged(e, data) {
      data.SelectedKeys = this.isTreeKeySelected(data, data.listItems);
      data.Value = data.SelectedKeys.join(", ");
    },

    getSelectedItems(data) {
      var result = [];
      if (!data.listItems) {
        return [];
      }
      data.listItems.forEach((m) => {
        if (m.items) {
          m.items
            .filter((i) => i.selected == true)
            .forEach((i) => {
              result.push(i);
            });
        }
      });
      return result;
    },
    processGrouped(data) {
      var list = data.SelectBoxItems;
      switch (data.AtyId) {
        case 14:
        case 20:
        case 21:
          break;
        default:
          return data.listItems ? data.listItems : [];
      }
      if (data.listItems) {
        return data.listItems;
      }
      var selectedKeys = data.SelectedKeys;
      var allItems = [];
      var result = list
        .filter((m) => {
          return m.ParentValue == null || m.ParentValue == "";
        })
        .map((m) => {
          var subItems = [];
          var ele1 = {
            value: m.Value,
            parentValue: m.ParentValue,
            items: m.Items.map((i) => {
              var ele2 = {
                value: i.Value,
                parentValue: i.ParentValue,
                text: i.Text,
                expand: true,
                selected: selectedKeys.indexOf(i.Value) >= 0,
                item: i,
              };
              subItems.push(ele2);
              return ele2;
            }),
            text: m.Text,
            selected: false,
          };
          allItems.push(ele1);
          subItems.forEach((m) => allItems.push(m));
          return ele1;
        });
      data.hasParents = list.filter((m) => m.ParentValue > 0).length > 0;
      //if (!data.hasParents) {
      result.forEach((m) => {
        m.selected = selectedKeys.indexOf(m.value) >= 0;
      });
      //}
      data.listItems = result;
      data.allItems = data.hasParents ? allItems : result;
      return result;
    },
    backToOverview(e) {
      e.event.preventDefault();
      this.loading = false;
      this.visible = false;
      this.popup.visible = false;
      this.$emit("closing");
    },
    update(e) {
      this.loading = true;
      e.event.preventDefault();
      this.SaveGenericFormData({ submit: false, args: this.args }).then(() => {
        this.loading = false;
        this.visible = false;
        this.popup.visible = false;
        this.$emit("closing");
        this.$emit("changed");
      });
    },
    //getDeepLink() {
    //    this.loading = true
    //    this.$store.dispatch("getDeepLink", { topicId = this.topicId })
    //        .then(res => {
    //            console.log(res);
    //            this.loading = false;
    //        });
    //},
    deleteTopic() {
      let msg =
        this.currentTopicStatus.DeleteButtonMessage &&
        this.currentTopicStatus.DeleteButtonMessage.length > 0
          ? this.currentTopicStatus.DeleteButtonMessage
          : "Are you sure you want to delete this record?";
      let result = confirm(msg, "Confirm Deletion");
      result.then((dialogResult) => {
        if (dialogResult) {
          this.loading = true;
          this.deleteTopicEx({
            topicId: this.currentTopicId,
            args: this.args,
          }).then((res) => {
            if (res.success) {
              // todo this.backToOverview();
            } else {
              this.loading = false;
            }
          });
        }
      });
    },
    deleteTopicEx({ commit }, { topicId, args }) {
      return axios
        .get(topicServiceUri + "/DeleteTopic", { params: { topicId, args } })
        .then((res) => {
          window.LoadPanel.Hide();
          if (res.data.success == true) {
            commit("DELETE_TOPIC", res.data);
            return res.data;
          } else {
            alert(res.data.errorMessage, "Delete Record");
            return res.data;
          }
        });
    },
    onSubmit(e) {
      if (this.submitAction) {
        this.submitAction();
        this.submitAction = null;
        e.preventDefault();
        return;
      }
      this.loadingStatus = true;
      this.loading = true;
      e.preventDefault();
      this.SaveGenericFormData({ submit: true, args: this.args }).then(
        (res) => {
          this.loading = false;
          if (res.data.success) {
            if (res.data.complete != true) {
              alert(
                "Your application is not complete! Check the following fields: " +
                  (res.data.missingItems
                    ? res.data.missingItems
                        .map((m) => m.FieldCaption)
                        .join(", ")
                    : "???"),
                "Submission"
              );
            } else {
              // Todo this.backToOverview();
            }
          } else {
            alert("Something went wrong!", "Submission");
          }
        }
      );
    },
    handleMultiSelectText(items, keys, data) {
      if (items && keys && keys.length > 0) {
        data.Value = keys.join(",");
        return items
          .filter((m) => keys.includes(m.Value))
          .map((m) => {
            return '<li class="msbEntry">' + m.Text + "</li>";
          })
          .join("");
      } else {
        data.Value = null;
        return "<li class='msbNoEntry'>- please select -</li>";
      }
    },
    handleDisplayText(items, data) {
      if (data.Value > 0) {
        var result = "";
        let item = data.SelectBoxItems.find((m) => m.Value == data.Value);
        if (item) {
          result = item.Text;
        }
        data.SelectedText = result;
        return result;
      } else {
        return "--";
      }
    },
    handleIcon(items, data) {
      if (data.Value > 0) {
        let item = data.SelectBoxItems.find((m) => m.Value == data.Value);
        if (item) {
          return item.Icon;
        }
      } else {
        return "--";
      }
    },
    makeBreaks(text) {
      return "<p>" + text.replace(/\n/g, "</p><p>") + "<p>";
    },
    removeFormatting(text) {
      var result = text.replace(/font-family:[^;]*;/gm, "");
      result = result.replace(/font-size:[^;]*;/gm, "");
      result = result.replace(/background-color:[^;]*;/gm, "");
      result = result.replace(/color:[^;]*;/gm, "");
      return result;
    },
    isUrl(value) {
      return /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
        value
      );
    },
    openDetail(topicId) {
      this.goto(topicId);
    },
    //////////
    openLinkedDetail(topicId) {
      var data = {
        action: "view",
        id: topicId,
        list: [topicId],
        args: this.args,
      };
      var url = window.location.pathname;
      window.post(url, data);
      //this.goto(topicId);
    },
    goto(topicId) {
      this.topicId = topicId;
      this.loading = true;
      this.loadingLinkListVisible = true;
      this.getTopicLinkListEx({ topicId, withPhoto: false }).then(() => {
        this.loadingLinkListVisible = false;
      });
      Promise.all([
        this.GetGenericFormData({ args: this.args, topicId: this.topicId }),
        this.getTopicAccess({ args: this.args, topicId: this.topicId }),
        this.getActionListByWorkflow({ args: this.args, topicId: topicId }),
      ]).then(([formRes]) => {
        const baseReadOnly =
          formRes && formRes.data ? !!formRes.data.ReadOnly : false;
        this.formIsReadOnly = baseReadOnly || this.topicAccess.Update !== true;
        this.loading = false;
      });
    },
    gotoFirst() {
      this.goto(this.topicIdList[0]);
    },
    gotoPrevious() {
      var id = this.topicIdList.indexOf(this.currentTopicId) - 1;
      this.goto(this.topicIdList[id]);
    },
    gotoNext() {
      var id = this.topicIdList.indexOf(this.currentTopicId) + 1;
      this.goto(this.topicIdList[id]);
    },
    gotoLast() {
      var id = this.topicIdList.length;
      this.goto(this.topicIdList[id - 1]);
    },
    addUploadParameter(e, data) {
      var minHeight =
        data.MatOptionsParsed && data.MatOptionsParsed.MinHeight
          ? data.MatOptionsParsed.MinHeight
          : 0;
      var minWidth =
        data.MatOptionsParsed && data.MatOptionsParsed.MinWidth
          ? data.MatOptionsParsed.MinWidth
          : 0;
      this.uploadUrl =
        applicationServiceUri +
        "/UploadDocument" +
        window.location.search +
        "&MatId=" +
        data.MatId +
        "&TopicId=" +
        this.topicId;
      e.component.option("uploadUrl", this.uploadUrl);
      if (data.MediaType == "Picture" && (minHeight > 0 || minWidth > 0)) {
        var imgInfo = this.calculateImageSize(e.value[0]);
        imgInfo.then((m) => {
          if (m.width < minWidth || m.height < minHeight) {
            alert(
              "The image is too small.The minimum size is " +
                "Please upload an image with a size of at least " +
                minWidth +
                "x" +
                minHeight +
                " px.",
              "Image Size"
            );
            e.component.option("value", []);
          }
        });
      }
    },
    calculateImageSize(file) {
      if (!file) {
        return new Promise(() => {});
      }
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
          resolve({ width: this.width, height: this.height });
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
      });
    },
    fileValidating(e, data) {
      if (e.rule && e.value && e.value.length > 0) {
        var minHeight =
          data.MatOptionsParsed && data.MatOptionsParsed.MinHeight
            ? data.MatOptionsParsed.MinHeight
            : 0;
        var minWidth =
          data.MatOptionsParsed && data.MatOptionsParsed.MinWidth
            ? data.MatOptionsParsed.MinWidth
            : 0;
        if (data.MediaType == "Picture" && (minHeight > 0 || minWidth > 0)) {
          var imgInfo = this.calculateImageSize(e.value[0]);
          return imgInfo.then((m) => {
            if (m.width < minWidth || m.height < minHeight) {
              (e.rule.message =
                "The image is too small.The minimum size is " +
                "Please upload an image with a size of at least " +
                minWidth +
                "x" +
                minHeight +
                " px."),
                "Image Size";
              e.rule.isValid = false;
              e.validator.validate();
              return false;
            } else {
              e.rule.isValid = true;
              e.validator.validate();
              return true;
            }
          });
        }
      }
      return true;
    },
    fileUploaded(e, data) {
      var response = JSON.parse(e.request.responseText);
      if (response.success) {
        response.files.forEach((m) => {
          data.Value.push(m);
        });
      } else {
        alert(response.errorMessage, "File Upload");
      }
    },
  },
  props: {
    showStatusInfo: {
      type: Boolean,
      required: false,
    },
    showLinkStatusInfo: {
      type: Boolean,
      required: false,
    },
    showGrids: {
      type: Boolean,
      required: false,
    },
    showAdminInfos: {
      type: Boolean,
      required: false,
    },
    showStatusActions: {
      type: Boolean,
      required: false,
    },
    showLinkStatusActions: {
      type: Boolean,
      required: false,
    },
    showNetworkList: {
      type: Boolean,
      required: false,
    },
    showOwner: {
      type: Boolean,
      required: false,
    },
  },
};
</script>
<style>
.crmCaption {
  font-weight: bold;
}

.assigneeSelectionValue .dx-tag-remove-button::before {
  padding-left: 3px;
}

.crmAbassadorAction span.dx-button-text {
  text-decoration: underline;
  color: #d44c22;
  font-size: 14px;
}

.tpc-date {
  font-weight: normal;
}
</style>
<style scoped>
.drawer-title.drawer-status-text span {
  padding: 10px;
}

.puCellTpl {
  display: contents;
}

.dx-show-invalid-badge.dx-numberbox.dx-texteditor.dx-editor-filled.dx-state-readonly.dx-widget.crmValidationBox.dx-validator.dx-visibility-change-handler {
  display: none;
}

.dx-datagrid {
  padding: 10px;
}

/*multiselect popup hide texeditor*/
.crmMultiSelectListText .dx-texteditor.dx-editor-filled.dx-state-hover {
  background: none;
}

.tlLTopicId {
  font-weight: 600;
}

.tlStatus {
  color: var(--m02-color-1);
  align-self: self-end;
}

.crmPhotoBox img {
  border-radius: 50%;
  height: 150px;
  object-fit: cover;
  width: 150px;
}

.tlLinkTemplate {
  cursor: pointer;
  align-self: flex-end;
}

.tlLinkTemplate span {
  color: var(--m01-color-1);
}

.statusChangedby {
}

.crmAbassadorAction {
  padding: 0;
  margin-top: -5px;
}

.crmOwnerValue.crmControl {
  display: grid;
  width: 100%;
  grid-template-columns: auto auto;
}

.crmMultiSelectListText .dx-validator {
  background: none;
}

div#cisTey {
  display: grid;
  justify-content: right;
  grid-template-columns: 700px;
}

.crmCaption {
  font-weight: bold;
  padding-bottom: 10px;
}

.crmDescription {
  padding-bottom: 10px;
}

.tlStatusList {
  display: flex;
  gap: 10px;
  color: #d44c22;
  text-decoration: underline;
  cursor: pointer;
  justify-content: right;
  align-items: self-end;
}

.ttlIcon {
  text-align: center;
  padding-right: 2px;
}

.crmControl {
}

.crmRequired {
}

.crmDescription {
}

.crmUpload .dx-fileuploader-wrapper {
  padding-left: 0;
}

.crmImageBox {
  display: flex;
  gap: 10px;
  box-sizing: border-box;
  flex-wrap: wrap;
  row-gap: 34px;
}

.crmDownload {
  overflow: hidden;
  white-space: nowrap;
  /* word-break: break-all; */
  /* color: black; */
  font-size: 12px;
  padding: 7px 0;
  position: relative;
  /*left: 44px;*/
  /*top: 50px;*/
  z-index: 99;
  top: 7px;
  left: 100px;
}

.crmDownloadReadonly.crmDownloadReadonly {
  position: unset;
  display: none;
}

.crmDownload a {
  font-weight: 500;
  color: var(--m02-color-1);
  text-decoration: none;
}

.crmImages img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.crmImages {
  height: 200px;
  border: 1px solid silver;
  border-radius: 4px;
  width: 100%;
  padding: 2px;
}

.crmImageDiv,
.crmImage {
  height: 100%;
  text-align: center;
}

.crmImage i {
  font-size: 152px;
  padding: 24px;
  color: #00a4e0;
}

.crmImage i:hover {
  color: #ea733b;
}

.crmContents {
  display: contents;
}

.crmContents.crmHeader {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  margin-bottom: 10px;
  font-size: 15px;
}

.crmContents p {
  padding-bottom: 5px;
}

.crmContentsTitel {
  display: contents;
  color: var(--m02-color-1);
  font-weight: 600;
}

.crmImages {
  break-inside: avoid-column;
}

.crmButtons {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
}

.crmWidget {
  margin-bottom: 10px;
}

.msbListBox {
  min-height: 20px;
}

.msbList {
  display: block;
  list-style-type: disc;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

li.msbNoEntry {
  list-style: none;
}

.msbEntry {
}

.crmControl {
  break-inside: auto;
}

div#cisTey.crmReadOnly {
  width: auto;
}

/* .crmReadOnly .crmContentArea {
        column-width: 300px;
        min-height: calc(100vh - 200px);
        column-count: 10;
    }*/

.crmReadOnly .crmContentArea {
  display: block;
  column-gap: 10px;
  column-fill: balance-all;
  padding: 20px;
}

.crmReadOnly .crmContentArea .crmElements {
  margin-bottom: 10px;
  padding: 0;
}

.crmReadOnly .crmControl {
  margin-bottom: 20px;
}

/*.crmReadOnly .crmDownload {
        padding: 10px 5px;
    }*/

.crmContentArea {
  max-width: 750px;
  padding-bottom: 20px;
}

.crmElements {
  padding: 20px;
  margin-bottom: 20px;
}

.crmVotingArea {
  break-before: column;
}

.crmReadOnly .crmElements {
  display: block;
  break-inside: avoid;
  break-before: auto;
}

.crmReadOnly .crmBreakInside {
  break-inside: auto;
  break-before: column;
}

.crmReadOnly .crmCaption {
  break-after: avoid;
  break-inside: avoid;
  padding: 3px 0 0px 0;
  box-sizing: border-box;
  margin-bottom: 8px;
  border-radius: 2px;
}

.crmReadOnly .msbSelectBox {
  display: block;
}

.crmTitle {
  font-size: 20px;
  margin-top: -5px;
  margin-bottom: 22px;
}

.crmReadOnly ul.msbList {
  padding: 0;
  margin: 5px 0;
}

.controlHeader {
  display: flex;
  gap: 10px;
}

.crmNavigator {
  gap: 5px;
  display: flex;
  margin-top: -2px;
}

.crmStatusButtons {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.crmCurrentStatus {
  color: var(--m02-color-1);
}

.crmStatusButton {
}

.crmStatusButton .crmStatusAction {
  color: #d44c22;
  text-decoration: underline;
  cursor: pointer;
}

.msbSelectBox i {
  font-size: 40px;
  color: var(--danger-color);
}

.msbSelectBox {
  display: flex;
  gap: 10px;
}

.sbList {
  align-self: center;
}

.crmCommentArea {
  break-inside: avoid;
  break-before: column;
}

#cisTey .crmCommentArea .crmCaption {
}

.vdIcon {
  font-size: 36px;
  color: var(--danger-hover-color);
  margin: 10px 10px 10px 0;
  vertical-align: middle;
}

.vdIcon:hover {
  color: var(--flag-color-4);
}

.ttlIcon .vdIcon {
  font-size: 18px;
  margin: 0;
}

a.crmContents.crmHyperlink {
  color: #e97035;
}

.crmTitleCaption {
  font-size: 25px;
  padding-bottom: 20px;
}

.crmPageTitle {
  text-align: center;
}

.tlLinkItem {
  display: contents;
}

.tlLinkItem .tlLinkId:hover,
.tlLinkItem .tlLinkTitle:hover {
  /*  font-weight: bold;*/
  cursor: pointer;
  color: var(--main-color-2);
}

.tlLinkListBox {
  display: grid;
  grid-template-columns: auto auto auto auto auto 1fr;
  gap: 10px;
  font-size: 14px;
  padding-bottom: 20px;
}

.crmElements.tlLinkList {
}

.cluster-class .crmCaption {
}

.cluster-class .nodes .crmCaption {
  background-color: var(--m01-color-1);
}

.vdIcon .tooltiptext {
  visibility: hidden;
  width: 120px;
  color: black;
  background-color: var(--page-bg-color);
  font-family: var(--font-family);
  font-size: 12px;
  margin-left: 10px;
  /*text-align: center;*/
  border-radius: 6px;
  padding: 10px;
  /* Position the tooltip */
  position: absolute;
  box-shadow: 1px 2px 6px #888888;
  width: auto;
  max-width: 500px;
  z-index: 1;
  line-height: 1.3em;
}

.dx-show-invalid-badge.crmValidationBox.dx-validator {
  margin-top: 0;
}

.crmBackButton {
  margin-left: -8px;
}

.crmValidationBox input.dx-texteditor-input {
  visibility: hidden;
  height: 0;
  border: 0;
}

.crmImageDelete {
  position: relative;
  z-index: 100;
  top: -39px;
}

.vdIcon:hover .tooltiptext {
  visibility: visible;
}

.tlLinkType.crmCaption {
}

div#treeview {
  height: 250px;
  border: solid 1px silver;
  overflow: hidden;
}

.crmMaxLen {
  float: right;
  font-size: 12px;
}

.crmElementHeader {
  display: flex;
  justify-content: flex-start;
}

.crmDocumentDiv {
  width: 160px;
}

#app ul.crmMultiSelectListText {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  list-style: none;
  margin: 0;
  padding: 0;
  list-style-type: none;
  margin-bottom: -40px;
}

#app ul.crmMultiSelectListText .dx-texteditor-input-container {
  color: transparent;
}

#app li.crmMultiSelectItem {
  display: grid;
  grid-template-columns: auto auto;
  gap: 5px;
  margin: 0;
  border: solid 1px silver;
  border-radius: 5px;
  padding: 10px;
  text-align: left;
  align-items: center;
  z-index: 99;
  background: white;
}

#app span.crmMultiSelectItemDelete {
  cursor: pointer;
  color: #ea7034;
}

#app span.crmMultiSelectItemDelete:hover {
  color: #00a4e0;
}

#app li.crmMultiSelectItemAdd {
  text-align: center;
  cursor: pointer;
  color: #ea7034;
}

#app li.crmMultiSelectItemAdd:hover {
  color: #00a4e0;
}

#app .crmMultiSelectIconAdd {
  padding-left: 5px;
}

.crmPopupContent {
  height: 100%;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto 1fr;
}

.crmNoPhoto {
  padding-bottom: 20px;
}

.crmPopupBody {
  display: contents;
}

.crmPopupFooter {
  justify-self: end;
  padding-top: 20px;
}

.crmNavigator .dx-button-content i:before {
  color: #0084b5;
  font-size: 15px;
}

.crmNavigator .dx-button-mode-text.dx-state-focused,
.crmNavigator .dx-button-mode-text.dx-state-hover {
  background: transparent;
  color: #d44c22;
}

.page-content {
  width: 100%;
  display: grid;
  grid-template-columns: auto auto;
  margin: 10px 0px 10px 0px;
}

.crmStatusSubmitButtons {
  display: contents;
}

@media only screen and (max-width: 1200px) {
  div#cisTey {
    grid-template-columns: 600px;
  }

  .img-bg {
    display: none;
  }
}

.crmPhotoBox {
  display: flex;
  flex-direction: column;
  max-width: 200px;
}

.crmPhotoBox img {
  margin-bottom: 20px;
}

@media only screen and (max-width: 600px) {
  .crmButtons {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-evenly;
  }

  div#cisTey {
    grid-template-columns: 400px;
  }
}

@media only screen and (max-width: 350px) {
  div#cisTey {
    grid-template-columns: 250px;
  }
}

.crmCheckbox {
  margin-left: 10px;
}

.pqHeadFirst {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

input[type="range"] {
  -webkit-appearance: none !important;
  outline: none !important;
  opacity: 0.7 !important;
  -webkit-transition: 0.2s !important;
  transition: opacity 0.2s !important;
}

input[type="range"]:hover {
  opacity: 1 !important;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  appearance: none !important;
  background: red !important;
}

input[type="range"]::-moz-range-thumb {
  background: #e97035 !important;
}

input[type="range"]::-webkit-slider-thumb {
  background: #e97035 !important;
}

input[type="range"]::-webkit-slider-runnable-track {
  background: #00a3df !important;
}
/*    div.dx-texteditor-input-container input.dx-texteditor-input {
        padding: 20px 156px 3px !important;
    }*/
.drawer-elements,
.drawerGrid-elements {
  background-color: rgba(0, 164, 224, 0.08);
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
}

.grid-element {
  margin-top: 10px;
}

.drawer-btn {
  width: 100%;
  margin-bottom: 1px;
  padding-right: 20px;
  padding-left: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
}

.drawers {
  margin-bottom: 15px;
}

.crmElements.drawer {
  padding: 0px;
}

.slack-class.crmElements {
  padding-top: 0px;
}

.slack-class .crmMaxLen {
  display: none;
}

.slack-checkbox-class {
  padding-bottom: 10px;
  margin-bottom: -10px;
}

.slack-class .crmDescription {
  margin-top: -17px;
}

.puCell {
  display: grid;
  grid-template-columns: auto auto;
  gap: 20px;
  min-width: 300px;
}

.dx-overlay-content .dx-item.dx-treeview-item {
  margin-left: 0;
}

.formBox {
  min-width: 600px;
}
</style>
